// Generic Data Container ( Former Row )
export const GENERIC_DATA_CONTAINER_UPDATE = 'GENERIC_DATA_CONTAINER_UPDATE';
export const GENERIC_DATA_CONTAINER_ERROR = 'GENERIC_DATA_CONTAINER_ERROR';
export const GENERIC_DATA_CONTAINER_RECEIVE = 'GENERIC_DATA_CONTAINER_RECEIVE';

// Modal
export const GENERIC_MODAL_DATA_CONTAINER_RECEIVE =
    'GENERIC_MODAL_DATA_CONTAINER_RECEIVE';
export const GENERIC_MODAL_DATA_CONTAINER_UPDATE =
    'GENERIC_MODAL_DATA_CONTAINER_UPDATE';
export const GENERIC_MODAL_DATA_UPDATE_FIELDS =
    'GENERIC_MODAL_DATA_UPDATE_FIELDS';
export const GENERIC_MODAL_DATA_VIEW_ALL_ROWS =
    'GENERIC_MODAL_DATA_VIEW_ALL_ROWS';
export const GENERIC_MODAL_DATA_VIEW_RECEIVE =
    'GENERIC_MODAL_DATA_VIEW_RECEIVE';
export const GENERIC_MODAL_DATA_VIEW_INIT = 'GENERIC_MODAL_DATA_VIEW_INIT';

export const CART_RECEIVE = 'CART_RECEIVE';

export const GENERIC_DATA_VIEW_LOAD = 'GENERIC_DATA_VIEW_LOAD';
export const GENERIC_DATA_VIEW_SHOW_MODAL = 'GENERIC_DATA_VIEW_SHOW_MODAL';
export const GENERIC_DATA_ROW_UPDATE = 'GENERIC_DATA_ROW_UPDATE';
export const GENERIC_DATA_ROW_RECEIVE = 'GENERIC_DATA_ROW_RECEIVE';
export const GENERIC_DATA_ROW_ERROR = 'GENERIC_DATA_ROW_ERROR';
export const GENERIC_DATA_VIEW_SET_CURRENT_PAGE_ID =
    'GENERIC_DATA_VIEW_SET_CURRENT_PAGE_ID';
export const GENERIC_DATA_VIEW_SET_DATA_TYPE =
    'GENERIC_DATA_VIEW_SET_DATA_TYPE';
export const GENERIC_DATA_VIEW_SET_NOT_LOGGED_ON =
    'GENERIC_DATA_VIEW_SET_NOT_LOGGED_ON';
export const GENERIC_DATA_VIEW_ALL_ROWS = 'GENERIC_DATA_VIEW_ALL_ROWS';
export const GENERIC_DATA_VIEW_SET_SEARCH_PENDING_STATUS =
    'GENERIC_DATA_VIEW_SET_SEARCH_PENDING_STATUS';
export const GENERIC_DATA_VIEW_UPDATE_CART_TABS =
    'GENERIC_DATA_VIEW_UPDATE_CART_TABS';
export const GENERIC_DATA_VIEW_GET_HEADER_INFORMATION_DATA =
    'GENERIC_DATA_VIEW_GET_HEADER_INFORMATION_DATA';
export const GENERIC_DATA_VIEW_RECEIVE = 'GENERIC_DATA_VIEW_RECEIVE';
export const GENERIC_DATA_VIEW_LOAD_ERROR = 'GENERIC_DATA_VIEW_LOAD_ERROR';
export const GENERIC_DATA_VIEW_SHOWEDITFILES =
    'GENERIC_DATA_VIEW_SHOWEDITFILES';
export const GENERIC_DATA_VIEW_FILES_WILLBEADDED =
    'GENERIC_DATA_VIEW_FILES_WILLBEADDED';

export const DROPZONE_SUBMIT_ERROR = 'DROPZONE_SUBMIT_ERROR';
export const ORDER_SCANNING_RECEIVE = 'ORDER_SCANNING_RECEIVE';

export const FIELD_CONFIGURATOR_RECEIVE = 'FIELD_CONFIGURATOR_RECEIVE';
export const FIELD_CONFIGURATOR_ERROR = 'FIELD_CONFIGURATOR_ERROR';
export const FIELD_CONFIGURATOR_UPDATE_SELECTED_FIELDS =
    'FIELD_CONFIGURATOR_UPDATE_SELECTED_FIELDS';

export const GENERIC_DATA_FORM_SUBMITBUTTON = 'GENERIC_DATA_FORM_SUBMITBUTTON';
export const GENERIC_DATA_FORM_LOADING = 'GENERIC_DATA_FORM_LOADING';
export const GENERIC_DATA_FORM_RECEIVE = 'GENERIC_DATA_FORM_RECEIVE';
export const GENERIC_DATA_FORM_ERROR = 'GENERIC_DATA_FORM_ERROR';

export const GENERIC_DATA_VIEW_CHANGES_MADE = 'GENERIC_DATA_VIEW_CHANGES_MADE';
export const GENERIC_DATA_VIEW_CHANGES_MADE_MODAL =
    'GENERIC_DATA_VIEW_CHANGES_MADE_MODAL';

export const GENERIC_DATA_FIELD_LOAD = 'GENERIC_DATA_FIELD_LOAD';
export const GENERIC_DATA_FIELD_LOAD_ERROR = 'GENERIC_DATA_FIELD_LOAD_ERROR';
export const GENERIC_DATA_FIELD_RECEIVE = 'GENERIC_DATA_FIELD_RECEIVE';
export const GENERIC_DATA_FIELD_LIST_RECEIVE =
    'GENERIC_DATA_FIELD_LIST_RECEIVE';
export const GENERIC_DATA_FIELD_ROW_UPDATE = 'GENERIC_DATA_FIELD_ROW_UPDATE';
export const GENERIC_DATA_FIELD_GET_DATA_LIST =
    'GENERIC_DATA_FIELD_GET_DATA_LIST';
export const GENERIC_DATA_FIELD_GET_ORGANIZATION_LIST =
    'GENERIC_DATA_FIELD_GET_ORGANIZATION_LIST';
export const GENERIC_DATA_UPDATE_FIELDS = 'GENERIC_DATA_UPDATE_FIELDS';

export const GENERIC_DATA_FIELD_SET_ARTICLES_LIST =
    'GENERIC_DATA_FIELD_SET_ARTICLES_LIST';
export const GENERIC_DATA_FIELD_SET_EXISTING_ARTICLES_LIST =
    'GENERIC_DATA_FIELD_SET_EXISTING_ARTICLES_LIST';
export const GENERIC_DATA_FIELD_RESET_STATE = 'GENERIC_DATA_FIELD_RESET_STATE';

export const GENERIC_SEARCH_QUERY = 'GENERIC_SEARCH_QUERY';
export const GENERIC_SEARCH_RECEIVE = 'GENERIC_SEARCH_RECEIVE';
export const GENERIC_SEARCH_ERROR = 'GENERIC_SEARCH_ERROR';
export const GENERIC_SEARCH_SHOW_FULL_FORM = 'GENERIC_SEARCH_SHOW_FULL_FORM';
export const GENERIC_SEARCH_SELECT_ITEM = 'GENERIC_SEARCH_SELECT_ITEM';
export const GENERIC_SEARCH_TOGGLE_SHOW_RESULT =
    'GENERIC_SEARCH_TOGGLE_SHOW_RESULT';
export const GENERIC_SEARCH_QUERY_GRIDTYPE = 'GENERIC_SEARCH_QUERY_GRIDTYPE';
export const GENERIC_SEARCH_RESET_STATE = 'GENERIC_SEARCH_RESET_STATE';
export const SET_BUTTON_INPROGRESS = 'SET_BUTTON_INPROGRESS';

export const GUID_EMPTY = '00000000-0000-0000-0000-000000000000';

// Sending full view

export const GENERIC_DATA_VIEW_STATUS_SENDING_ALL_FORMS =
    'GENERIC_DATA_VIEW_STATUS_SENDING_ALL_FORMS';
export const GENERIC_DATA_VIEW_UPDATE_DIRTY_FIELDS =
    'GENERIC_DATA_VIEW_UPDATE_DIRTY_FIELDS';
export const GENERIC_MODAL_DATA_VIEW_UPDATE_DIRTY_FIELDS =
    'GENERIC_MODAL_DATA_VIEW_UPDATE_DIRTY_FIELDS';
export const GENERIC_DATA_VIEW_CLEAR_ALL_DIRTY_FIELDS =
    'GENERIC_DATA_VIEW_CLEAR_ALL_DIRTY_FIELDS';
export const GENERIC_MODAL_DATA_VIEW_DIRTY_FIELDS_ALL_FORMS =
    'GENERIC_MODAL_DATA_VIEW_DIRTY_FIELDS_ALL_FORMS';


export const GENERIC_MODAL_DATA_VIEW_ADD_DIRTY_FIELD = 'GENERIC_MODAL_DATA_VIEW_ADD_DIRTY_FIELD';
export const GENERIC_DATA_VIEW_ADD_DIRTY_FIELD = 'GENERIC_DATA_VIEW_ADD_DIRTY_FIELD';

export const TEMP_OBJECTS_UPDATE =
    'TEMP_OBJECTS_UPDATE';

export const GLOBAL_DATA_CONFIGURATOR_RECEIVE =
    'GLOBAL_DATA_CONFIGURATOR_RECEIVE';

export const GENERIC_DATA_FORM_SAVE_UPDATING_CONTAINER_DATA =
    'GENERIC_DATA_FORM_SAVE_UPDATING_CONTAINER_DATA';

export const FILE_UPLOAD_UPDATE =
    'FILE_UPLOAD_UPDATE';